module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00317.e68e4759.jpg";